import request from '@/utils/request';

export function getProjectWorkInfo(id, userId, page) {
  return request({
    url: '/Project/impression',
    params: {
      id,
      userId,
      page,
    },
  });
}

export function getDiaryIndexData(id, userId, page) {
  return request({
    url: '/Project/diary',
    params: {
      id,
      userId,
      page,
    },
  });
}
